import { ApiBind, Common } from './common.model';
import { Page } from './page.model';
import { Publisher } from './publisher.model';
import { Site } from './site.model';

export class Placement extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'outer_placement_id' })
  outerPlacementId: string;

  @ApiBind({ column: 'name' })
  name: string;

  get longName(): string {
    return this.longPageName + ' » ' + this.name;
  }
  @ApiBind({ column: 'publisher', model: (value) => new Publisher(value) })
  publisher?: Publisher;

  @ApiBind({ column: 'site', model: (value) => new Site(value) })
  site?: Site;

  @ApiBind({ column: 'page', model: (value) => new Page(value) })
  page?: Page;

  get longPageName(): string {
    return this.publisher?.name + ' » ' + this.site?.name + ' » ' + this.page?.name;
  }

  /**
   * placement additional のis_flowingの値
   */
  @ApiBind({ column: 'has_assets' })
  hasAssets?: boolean;

  @ApiBind({ column: 'can_set_assets' })
  canSetAssets?: boolean;
}
